'use client';

import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';
import { useChatCopy } from '@/lib/chat-i18n';

export function UnsavedSettingsDialog({
  open,
  intent,
  onCancel,
  onDiscard,
}: {
  open: boolean;
  intent: 'back' | 'close' | null;
  onCancel: () => void;
  onDiscard: () => void;
}) {
  const copy = useChatCopy();
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent
        showCloseButton={false}
        className="max-w-[calc(100%-2rem)] gap-5 p-5 sm:max-w-sm"
      >
        <div className="flex flex-col gap-2">
          <DialogTitle>{copy.unsavedChanges}</DialogTitle>
          <DialogDescription>
            {intent === 'close' ? copy.unsavedCloseDescription : copy.unsavedBackDescription}
          </DialogDescription>
        </div>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="border-border min-h-11 rounded-md border px-4 text-sm font-medium"
          >
            {copy.continueEditing}
          </button>
          <button
            type="button"
            onClick={onDiscard}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90 min-h-11 rounded-xl px-4 text-sm font-semibold transition-colors duration-200"
          >
            {copy.discardChanges}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
